module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/cockroach.058d1fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product/cockroach.jpg
// module id = I9mM
// module chunks = 0